<fieldset [formGroup]="group" class="w-100 in-two-columns">
  <mat-form-field>
    <app-easy-select
      [label]="TITLE + 'SPECIAL_TYPE' | translate"
      formControlName="specialParameters"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [translatePrefixForSelected]="'PRODUCTS.SPECIAL_TYPE.'"
      [multiple]="true"
      [options]="specialParameters | toSelectOption: 'PRODUCTS.SPECIAL_TYPE.'"
    ></app-easy-select>
  </mat-form-field>

  <mat-form-field>
    <app-easy-input
      [label]="'PRODUCTS.SPECIAL_TYPE.OTHER' | translate"
      formControlName="specialParametersOther"
    ></app-easy-input>
  </mat-form-field>

  <mat-form-field>
    <app-easy-select
      [label]="TITLE + 'MARKETING_LABELS' | translate"
      formControlName="marketingLabels"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [translatePrefixForSelected]="'PRODUCTS.MARKETING_LABELS.'"
      [multiple]="true"
      [options]="marketingLabels | toSelectOption: 'PRODUCTS.MARKETING_LABELS.'"
      [limit]="2"
    ></app-easy-select>
  </mat-form-field>

  <mat-form-field>
    <app-easy-select
      [label]="TITLE + 'EXPERIENCE_CATEGORIES' | translate"
      formControlName="experienceCategories"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [translatePrefixForSelected]="'PRODUCTS.EXPERIENCE_CATEGORIES.'"
      [multiple]="true"
      [options]="
        experienceCategories | toSelectOption: 'PRODUCTS.EXPERIENCE_CATEGORIES.'
      "
      [limit]="2"
    ></app-easy-select>
  </mat-form-field>

  <mat-form-field>
    <app-easy-select
      [label]="TITLE + 'FOOD_PAIRINGS' | translate"
      formControlName="foodPairings"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [translatePrefixForSelected]="'PRODUCTS.FOOD_PAIRINGS.'"
      [multiple]="true"
      [options]="foodPairings | toSelectOption: 'PRODUCTS.FOOD_PAIRINGS.'"
      [limit]="3"
    ></app-easy-select>
  </mat-form-field>
</fieldset>
